"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelEnum = void 0;
var ChannelEnum;
(function (ChannelEnum) {
    ChannelEnum["Voice"] = "V";
    ChannelEnum["Chat"] = "C";
    ChannelEnum["Mail"] = "M";
    ChannelEnum["Form"] = "F";
    ChannelEnum["Sms"] = "S";
    ChannelEnum["InternalNote"] = "In";
})(ChannelEnum = exports.ChannelEnum || (exports.ChannelEnum = {}));
